// Vollea — Results Outstanding board (organiser / club admin / super admin)
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { IoChevronBack, IoTimeOutline, IoAlertCircleOutline, IoArrowForward } from "react-icons/io5";
import { Card, Empty } from "../components/ui-vollea";
import { api } from "../lib/api";
import { C, SP, R } from "../lib/theme";

const dateLabel = (iso) => {
  if (!iso) return "Date TBC";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "Date TBC";
  return d.toLocaleString(undefined, { weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

export default function Outstanding() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try { setItems(await api.get("/organiser/outstanding") || []); }
    catch { setItems([]); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div style={{ background: C.bg, minHeight: "100vh", padding: `${SP.lg}px ${SP.lg}px 90px` }}>
      <button onClick={() => navigate(-1)} data-testid="outstanding-back" style={{ color: C.text, marginBottom: SP.md }}>
        <IoChevronBack size={26} />
      </button>
      <h1 style={{ color: C.text, fontWeight: 700, fontSize: 28, margin: 0, letterSpacing: 0.5 }}>Results Outstanding</h1>
      <p style={{ color: C.textMuted, fontSize: 14, marginTop: 4 }}>Fixtures past their scheduled date with no result yet.</p>

      <div style={{ marginTop: SP.xl, display: "flex", flexDirection: "column", gap: SP.sm }}>
        {loading ? (
          <div style={{ textAlign: "center", color: C.lime, padding: SP.xl }}>Loading…</div>
        ) : items.length === 0 ? (
          <Empty icon={<IoAlertCircleOutline size={40} color={C.lime} />} text="All caught up — no overdue fixtures right now." testid="outstanding-empty" />
        ) : items.map((m) => (
          <Card
            key={m.match_id}
            testid={`outstanding-row-${m.match_id}`}
            onClick={() => navigate(`/matches/${m.match_id}`)}
            style={{ border: `1px solid ${C.warning}` }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: SP.sm }}>
              <span style={{ color: C.warning, fontWeight: 700, fontSize: 11, letterSpacing: 1, textTransform: "uppercase", display: "inline-flex", alignItems: "center", gap: 4 }}>
                <IoTimeOutline size={14} /> {m.days_overdue} day{m.days_overdue === 1 ? "" : "s"} overdue
              </span>
              <span style={{ color: C.lime, fontSize: 12, fontWeight: 600 }}>{m.league_name}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: C.text, fontWeight: 600, fontSize: 14, flex: 1 }}>{m.team_a_players?.map((p) => p.name.split(" ")[0]).join(" & ") || "TBC"}</span>
              <span style={{ color: C.textDim, fontWeight: 700, fontSize: 12, margin: `0 ${SP.md}px` }}>VS</span>
              <span style={{ color: C.text, fontWeight: 600, fontSize: 14, flex: 1, textAlign: "right" }}>{m.team_b_players?.map((p) => p.name.split(" ")[0]).join(" & ") || "TBC"}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: SP.md, paddingTop: SP.md, borderTop: `1px solid ${C.divider}` }}>
              <span style={{ color: C.textMuted, fontSize: 12 }}>{dateLabel(m.scheduled_at)} · Div {m.division || "—"}</span>
              <span style={{ color: C.warning, fontWeight: 700, fontSize: 12, letterSpacing: 1, display: "inline-flex", alignItems: "center", gap: 4 }}>
                CHASE <IoArrowForward size={14} />
              </span>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
